/// <reference path="../../types.d.ts" />
import { connect } from 'react-redux';
import { buildDispatchable } from '../../actions/_action-utilities';
import * as dispatchNavigation from '../../actions/navigation';
import { submitNewPassword, reduxSavePasswordDto } from '../../actions/forgot-password';
import ResetPassword from './reset-password';
import history from '../../history';
const mapStateToProps = function(state) {
    const { forgotPassword } = state;
    return {
        ...forgotPassword
    };
};
const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        dispatchNavigation: dispatchNavigation.navExport(dispatch),
        savePasswordResetParameters: async (token)=>{
            runDispatchable(()=>{
                return dispatch(reduxSavePasswordDto(token));
            });
        },
        save: async (newPasswordData)=>{
            runDispatchable(()=>{
                return dispatch(submitNewPassword(newPasswordData));
            });
        },
        handleNavigateHome: ()=>{
            runDispatchable(()=>{
                history.push('/');
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
